import strings from "translate/language";

export const CpType = [
  { label: `${strings.viaIndividual}`, value: 1 },
  { label: `${strings.viaCompany}`, value: 2 },
];

export const CONST_IDS = {
  cp_lead_source_id: "645b3a414194e4010913546c",
  ref_lead_source_id: "645b3a524194e40109135470",
};
